import { useState } from "react";
import { useAnalytics } from "../../contexts/analytics/hooks";
import { EmploymentType } from "../../utils/models";
import type { LocationPickerSelectionMeta } from "../LocationPicker/LocationPicker";
import { ADD_STAFF_ANALYTICS_SOURCE } from "./addStaffPublish";

const ALL_CONTRACT_TYPES: EmploymentType[] = Object.values(EmploymentType);

/** The panel's location and contract filter, each change tracked the way the old picker tracked it. */
export const useAddStaffFilters = (weekIndex: number, defaultRoom: string | undefined) => {
	// DEFAULT: no location ("No assignment") unless the caller opened the panel on one.
	const [selectedRoom, setSelectedRoom] = useState(defaultRoom ?? "");
	const [contractTypes, setContractTypes] = useState<EmploymentType[]>(ALL_CONTRACT_TYPES);
	const { track } = useAnalytics();

	const changeRoom = (location: string, meta: LocationPickerSelectionMeta, focusNurseId: number | undefined) => {
		setSelectedRoom(location);
		track("Location Picker Selected", {
			surface: "add-nurse",
			nurse_id: focusNurseId,
			location,
			below_par: meta.belowPar,
			recent_shifts: meta.recentShifts,
		});
	};

	const changeContractTypes = (value: EmploymentType[]) => {
		setContractTypes(value);
		track("Staffing - filter contract types", {
			source: ADD_STAFF_ANALYTICS_SOURCE,
			// "all" when nothing is filtered out (the old picker sent it for its empty = all state); otherwise
			// the enum values, comma-joined — `track` takes scalar properties only (the repo's list convention).
			contract_types: value.length === ALL_CONTRACT_TYPES.length ? "all" : value.join(","),
			week_index: weekIndex,
		});
	};

	return { selectedRoom, changeRoom, contractTypes, changeContractTypes };
};
